import { render, staticRenderFns } from "./DemandItem.vue?vue&type=template&id=b941e616&scoped=true"
import script from "./DemandItem.vue?vue&type=script&lang=ts"
export * from "./DemandItem.vue?vue&type=script&lang=ts"
import style0 from "./DemandItem.vue?vue&type=style&index=0&id=b941e616&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b941e616",
  null
  
)

export default component.exports